import React, { useState, useEffect } from "react";
import { Container, Typography } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import LoaderContainer from "../../components/LoaderContainer";
import CustomButton from "../../components/Custom/CustomButton";
import { useTranslation } from "react-i18next";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import CustomCard from "../../components/Famer/GenericCard";;
import { useNavigate } from "react-router-dom";
import { useAlert } from "../../components/Alert";

export default function AreaProject() {
  const [areaProject, setAreaProject] = useState([]);
  const { showAlert } = useAlert();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAreaManagers();
  }, []);

  const fetchAreaManagers = async () => {
    try {
      const response = await api.get("/areamanager/area-project/");
      setAreaProject(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching Area Managers:", error);
      setLoading(false);
      showAlert("error", "Error fetching Area Managers");
    }
  };


  const handleAddAreaManager = () => {
    navigate("/pop-manager/area-project/add");
  };

  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container
          maxWidth="xs"
          style={{
            height: areaProject.length === 0 ? "58vh" : "94vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          {areaProject.length !== 0 && (
            <CustomTitle>{t("Area Project List")}</CustomTitle>
          )}
          <div
            style={{
              overflowY: "auto",
              maxHeight: "calc(115vh - 300px)",
              textAlign: "center",
              height: "700px",
              margin: "auto",
            }}
          >
            {areaProject.map((manager) => (
              <CustomCard
                key={manager.id}
                id={manager.id}
                t={t}
                data={{
                  [t("Area Project name")]: manager.project_name,
                  [t("Description")]: manager.project_description,
                  [t("Location")]: manager.location,
                  [t("Area Covered")]: manager.area_covered,
                  [t("Area Manager")]: manager.area_manager,
                  [t("Total Project Cost (Rs.)")]: manager.total_project_cost  || "N/A",
                  [t("Expected Carbon Yield (MT)")]: manager.expected_carbon_yield || "N/A",
                }}
                disableChange={true}
                // handleEditClick={() => handleEditClick(manager.id)}
                // handleDelete={() => handleDelete(manager.id)}
                // handleView={() => handleLoginAreaManager(manager.id)}
                // viewLabel="Login"
              />
            ))}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <CustomButton onClick={handleAddAreaManager}>
              {t("Add Area Project")}
            </CustomButton>
            {areaProject.length === 0 && (
              <Typography variant="subtitle1" sx={{ textAlign: "center" }}>
                {t("Your Area Project will be shown here once you add them.")}
              </Typography>
            )}
          </div>
        </Container>
      </LoaderContainer>
    </>
  );
}
